import React from 'react';

import Banner from '@ad-scripts/presentation/components/common/banner';
import { Button as RawButton, ButtonTypes } from 'src/presentation/components/agent_desktop_components';
import styled from 'styled-components';

type BannerComponentType = {
  showPreview: boolean;
  autoAssignMessagingSessions: boolean;
};

export default function BannerComponent({
  showPreview,
  autoAssignMessagingSessions,
}: BannerComponentType): JSX.Element {
  const config = [
    {
      showBanner: !showPreview && autoAssignMessagingSessions,
      banner: (
        <Banner
          buttons={
            <Button buttonType={ButtonTypes.PRIMARY} contrast disabled>
              Save for later
            </Button>
          }
          titleList={['Incoming', 'Julie Chang']}
        />
      ),
    },
    {
      showBanner: showPreview && autoAssignMessagingSessions,
      banner: (
        <Banner
          buttons={
            <Button buttonType={ButtonTypes.PRIMARY} contrast disabled>
              Save for later
            </Button>
          }
          titleList={[
            'Incoming',
            'Julie Chang',
            <StyledBannerText key="text">Hi, I wanted to check my order...</StyledBannerText>,
          ]}
        />
      ),
    },
    {
      showBanner: !showPreview && !autoAssignMessagingSessions,
      banner: (
        <Banner
          buttons={
            <>
              <Button buttonType={ButtonTypes.TEXT} contrast disabled>
                Decline
              </Button>
              <Button buttonType={ButtonTypes.PRIMARY} contrast disabled>
                Accept
              </Button>
            </>
          }
          titleList={['Incoming', 'Julie Chang']}
        />
      ),
    },
    {
      showBanner: showPreview && !autoAssignMessagingSessions,
      banner: (
        <Banner
          buttons={
            <>
              <Button buttonType={ButtonTypes.TEXT} contrast disabled>
                Decline
              </Button>
              <Button buttonType={ButtonTypes.PRIMARY} contrast disabled>
                Accept
              </Button>
            </>
          }
          titleList={[
            'Incoming',
            'Julie Chang',
            <StyledBannerText key="text">Hi, I wanted to check my order...</StyledBannerText>,
          ]}
        />
      ),
    },
  ];
  return config.find(({ showBanner }) => showBanner)?.banner || config[0].banner;
}

const Button = styled(RawButton)`
  &:disabled {
    background: inherit;
    color: ${p => p.theme.colors.white};
  }
`;

const StyledBannerText = styled.div`
  font-weight: ${p => p.theme.fontWeight.normal};
`;
